export default "__VITE_ASSET__BGmtZcuK__"